<template>
    <el-input v-model="value" name="vat-toggle" label-classes="text-white opacity-80" :label="label" type="toggle"></el-input>
</template>

<script>
export default {
    name: 'Ui.VatToggle',

    props: {
        label: {
            type: String,
            required: true,
        },
    },

    data: () => {
        return {
            value: false,
        };
    },

    mounted() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if (params && typeof params.btw !== 'undefined') {
            this.value = params.btw === '1';
            this.$store.dispatch('setPricesIncludingVat', this.value);
        } else {
            this.value = this.$store.getters['pricesIncludingVat'];
        }
    },

    watch: {
        value() {
            this.$store.dispatch('setPricesIncludingVat', this.value);
        },
    },
};
</script>
